import PeopleIcon from '@mui/icons-material/People';
import { ListItemIcon, ListItemText, Typography } from '@mui/material';
import { HighlightedText } from 'features/brand-voice/components/BrandVoiceMenuItemContent';
import { TargetAudienceAvatar } from 'features/target-audience/components/TargetAudienceAvatar';
import { ModelTargetAudience } from 'services/backofficeIntegration/http/endpoints/target-audience/httpGetTargetAudiences';
import styled from 'styled-components';

type Props = {
  option: ModelTargetAudience;
  searchText?: string;
  isPersonal?: boolean;
};

export const TargetAudienceMenuItemContent = ({
  option,
  searchText = '',
  isPersonal = true,
}: Props) => (
  <>
    <ListItemIcon>
      <TargetAudienceAvatar thumbnailUrl={option._embedded?.image?.url} name={option.name} />
    </ListItemIcon>

    <ListItemText>
      <OptionText>
        <LimitedTypography>
          {searchText ? (
            <HighlightedText
              text={option.name || 'Unnamed Target Audience'}
              searchText={searchText}
            />
          ) : (
            option.name
          )}
        </LimitedTypography>
      </OptionText>
    </ListItemText>

    {!isPersonal && <PeopleIcon color="action" fontSize="small" />}
  </>
);

const OptionText = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: ${({ theme }) => theme.spacings.two};

  align-items: center;
`;

const LimitedTypography = styled(Typography)`
  font-size: inherit;
  color: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
